module.exports = __webpack_public_path__ + "static/media/4-square-onhold.ddc0c69d.svg";